import { Svg } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants/primitives';

import { Path } from '../../../ucl/components/svg/Svg';

export const AccountIcon = () => (
  <Svg width="$6" height="$6" viewBox="0 0 24 24" fill="none">
    <Path
      d="M12 12.3975C10.9 12.3975 9.95833 12.0058 9.175 11.2225C8.39167 10.4391 8 9.49746 8 8.39746C8 7.29746 8.39167 6.35579 9.175 5.57246C9.95833 4.78913 10.9 4.39746 12 4.39746C13.1 4.39746 14.0417 4.78913 14.825 5.57246C15.6083 6.35579 16 7.29746 16 8.39746C16 9.49746 15.6083 10.4391 14.825 11.2225C14.0417 12.0058 13.1 12.3975 12 12.3975ZM4 18.3975V17.5975C4 17.0308 4.14583 16.51 4.4375 16.035C4.72917 15.56 5.11667 15.1975 5.6 14.9475C6.63333 14.4308 7.68333 14.0433 8.75 13.785C9.81667 13.5266 10.9 13.3975 12 13.3975C13.1 13.3975 14.1833 13.5266 15.25 13.785C16.3167 14.0433 17.3667 14.4308 18.4 14.9475C18.8833 15.1975 19.2708 15.56 19.5625 16.035C19.8542 16.51 20 17.0308 20 17.5975V18.3975C20 18.9475 19.8042 19.4183 19.4125 19.81C19.0208 20.2016 18.55 20.3975 18 20.3975H6C5.45 20.3975 4.97917 20.2016 4.5875 19.81C4.19583 19.4183 4 18.9475 4 18.3975Z"
      fill={primitive.bk.$bbqBrown}
    />
  </Svg>
);
